import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment, InputBase, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { useParams } from 'react-router-dom';
import { actualizarTarea, getOpcionesCrearTareas, getProyectos, getUsuariosCliente } from '../../../services/apis';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import { formatMinutosHoras } from '../../../utils/utils';
import TimeCounter from '../../../utils/componentes-utiles/TimeCounter';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import { SelectorRoles } from './SelectorRoles';

export const FormEditarTarea = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, opclientes, cargarTareas, opTrabajadores, trabajadores, opcionesTipoTareas, }) => {
    const handleClose = () => {
        setOpen(false);
    };

    const parseStringToArray = (input) => {
        console.log('isArray?', Array.isArray(input), 'value:', input);

        if (Array.isArray(input)) {
            return input.map(Number).filter(n => !isNaN(n));
        }

        if (typeof input !== 'string') {
            return [];
        }

        try {
            return input
                .trim()
                .replace(/^\s*\[|\]\s*$/g, '') // elimina corchetes con espacios
                .split(',')
                .map(s => Number(s.trim()))
                .filter(n => !isNaN(n));
        } catch (e) {
            console.error('Error parsing input:', e);
            return [];
        }
    };

    const param = useParams();
    // Estados locales para los campos del formularioF

    const [tarea, setTarea] = useState(tareaInfo)

    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });
    const [time, setTime] = useState(0);
    const [usuarioSelec, setUsuarioSelec] = useState({ label: "Seleccione un Usuario", value: "0" });
    const [opUsuarios, setOpUsuarios] = useState([]);
    const [opProyectos, setOpProyectos] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [oculto, setOculto] = useState(false);
    const [proyectoSelec, setProyectoSelec] = useState({ label: 'Seleccione un Proyecto', value: "0" });
    const [tipoTarea, setTipoTarea] = useState({ label: 'Sin Tipo', value: "0" });
    const [roles, setRoles] = useState([])
    const [rolSelect, setRolSelect] = useState(parseStringToArray(tareaInfo.roles_permitidos));




    const opcionesOcultas = {
        SelectorRoles: <SelectorRoles roles={roles} setRoles={setRoles} rolSelect={rolSelect} setRolSelect={setRolSelect}></SelectorRoles>,
    };


    const handleChange = (event) => {
        if (event.target.name === "minutos") {

            let temp = formatMinutosHoras(event.target.value);
            console.log(temp);

            // const tareaNueva = { ...tarea, [event.target.name]: temp };

        } else if (event.target.name === "horas") {
            let value = parseInt(event.target.value, 10);

            if (value >= 0) {
                // No hay límite máximo para horas
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            } else {
                // Aseguramos que no sea negativo, ajustando a 0 si lo es.
                value = 0;
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            }
        } else {
            const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
            setTarea(tareaNueva);
        }
    };

    const cargarOpciones = async () => {
        try {
            const response = await getOpcionesCrearTareas();
            console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", response);

            if (response.success) {
                setOpciones(response.data)
                setRoles(response.roles)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }


    useEffect(() => {
        let clienteSeleccionado = opclientes.filter(opcion => tareaInfo.id_cliente == opcion.value);
        setClienteSelec(clienteSeleccionado[0]);
        cargarProyectos();
        cargarOpciones();
    }, [])

    useEffect(() => {
        const tareaNueva = { ...tarea, ['minutos']: time };
        console.log(time);

        setTarea(tareaNueva);
    }, [time])


    // Función para manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        // Aquí se puede manejar el envío de los datos (ejemplo: llamada a una API o validación)
        // Cierra el formulario
        editarTarea();
    };

    const editarTarea = async () => {
        console.log("hi");

        const nuevaTareaTmp = { ...tarea };
        console.log(clienteSelec);

        nuevaTareaTmp.id_cliente = clienteSelec ? clienteSelec.value : "0";
        nuevaTareaTmp.id_usuario = usuarioSelec ? usuarioSelec.value : "0";
        nuevaTareaTmp.id_proyecto = proyectoSelec ? proyectoSelec.value : "0";
        nuevaTareaTmp.trabajadores = trabajadorSelec;
        nuevaTareaTmp.tipo_tarea = tipoTarea.value;
        nuevaTareaTmp.roles_permitidos = rolSelect;

        if (nuevaTareaTmp.id_estado >= 3 && nuevaTareaTmp.minutos < 15) {
            setErrorAlert(true);
            return;
        }
        try {
            const response = await actualizarTarea(nuevaTareaTmp);
            console.log(response);

            if (response.success == true) {
                cargarTareas();
                setTarea({
                    'fecha': new Date(),
                    'asunto': null,
                    'descripcion': null,
                    'localizacion': null,
                    'id_cliente': null,
                    'id_usuario': null,
                    'minutos': null,
                    'horas': null,
                    'id_proyecto': param.id
                })
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" })
                handleClose();

            }


        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const cargarUsuarios = async (id) => {
        console.log("Cargando usuarios para cliente ID:", id);

        try {
            const response = await getUsuariosCliente(id);
            const newTmp = response.data.map(item => ({
                label: item.nombre,
                value: item.id
            }));

            setOpUsuarios(newTmp);

            // Encuentra el usuario correcto en la nueva lista en lugar de `opUsuarios`
            const usuarioSeleccionado = newTmp.find(opcion => opcion.value === tareaInfo.id_usuarioCliente);

            console.log("Usuario seleccionado:", usuarioSeleccionado);

            // Establece el usuario seleccionado (si existe)
            setUsuarioSelec(usuarioSeleccionado || { label: "Seleccione un Usuario", value: "0" });

        } catch (error) {
            console.error("Error al cargar usuarios", error);
        }
    };

    const cargarProyectos = async () => {
        try {
            const response = await getProyectos();
            setProyectos(response.data);
            iterarProyectos(response.data);

        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const iterarProyectos = (data) => {
        try {
            const tmp = [...data];
            const newTmp = [
                // Proyecto por defecto
                ...tmp.map((item) => ({
                    label: item.nombre,
                    value: item.id
                }))
            ];
            setOpProyectos(newTmp);
            console.log("Proyectos:", newTmp);
            let clienteSeleccionado = newTmp.filter(opcion => tareaInfo.id_proyecto == opcion.value);
            console.log("Cliente seleccionado:", opProyectos);

            setProyectoSelec(clienteSeleccionado[0]);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    useEffect(() => {
        if (clienteSelec && clienteSelec.value && clienteSelec.value !== "0") {
            cargarUsuarios(clienteSelec.value);
        }
    }, [clienteSelec]);
    useEffect(() => {
        if (tareaInfo && opcionesTipoTareas) {
            const tipoSeleccionado = opcionesTipoTareas.find(tipo => tipo.value === tareaInfo.id_tipo_tarea);
            setTipoTarea(tipoSeleccionado || { label: 'Sin Tipo', value: "0" });
        }
    }, [tareaInfo, opcionesTipoTareas]);
    return (
        <Dialog
            open={open}
            fullWidth
            width="md"
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
        >
            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h6">
                        Editar Tarea
                    </Typography>

                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </Grid>

                <form onSubmit={handleSubmit} style={{ minWidth: '100%' }}>
                    <Grid container xs={12} spacing={2} direction="column">
                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                name="Cliente"
                                options={opclientes}
                                value={clienteSelec}
                                onChange={(event, newValue) => {
                                    setClienteSelec(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} label="Cliente*" />}
                            />
                        </Grid>

                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opUsuarios ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opUsuarios}
                                value={usuarioSelec}
                                onChange={(event, newValue) => setUsuarioSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                className={opProyectos ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                name="Proyecto"
                                options={opProyectos}
                                value={proyectoSelec}
                                onChange={(event, newValue) => {
                                    setProyectoSelec(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} label="Proyecto*" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            Asignar:
                            <AutocompleteList array={opTrabajadores} arrayPre={trabajadores} setArray={setTrabajadorSelec}></AutocompleteList>
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opcionesTipoTareas ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opcionesTipoTareas}
                                value={tipoTarea}
                                onChange={(event, newValue) => setTipoTarea(newValue || { label: 'Sin Tipo', value: "0" })}
                                renderInput={(params) => <TextField {...params} label="Tipo Tarea*" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Descripción"
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                name="descripcion"
                                value={tarea.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={11.7}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs={12}
                            gap={2}
                            sx={{ mt: 2 }}
                        >
                            {/* <Grid item xs={5}>
                                <TextField
                                    fullWidth
                                    label="Horas"
                                    type="number"
                                    variant="outlined"
                                    name="horas"
                                    value={tarea.horas}
                                    onChange={handleChange}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    required
                                />
                            </Grid> */}
                            <TimeCounter time={time} setTime={setTime} tiempo={tarea.horas_totales} />
                        </Grid>

                        {opciones[0] && (
                            <Grid item xs={12}>
                                {opcionesOcultas[opciones[0].nombre]}
                            </Grid>
                        )}
                    </Grid>
                </form>
            </DialogContent>

            <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Editar Tarea
                </Button>
            </DialogActions>
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Minimo 15 minutos de trabajo"} />
                )

            }
        </Dialog>

    );
};